<template>
  <d-form-row class="m-0">
    <h6 class="mx-1 my-3">Agentes</h6>
    <ul class="mx-1 agent-list custom-striped">
      <li v-for="(model, index) in listAgents" :key="model.id">
        <d-form-row>
          <d-col class="col">
            <d-form-row class="mb-1">
              <d-col cols="3">
                <label>Data</label>
                <input type="text" class="form-control" placeholder="Data" v-model="model.date" required />
              </d-col>
              <d-col cols="3">
                <label>Agente
                  <small class="link" @click.prevent="openModalEditAgent(model.agent_id, 'chemical', index)">
                    {{ model.agent_id ? 'Editar' : ' Adicionar novo Agente' }}
                  </small>
                </label>
                <autocomplete
                  :ref="`autocomplete_agent_${index}`"
                  placeholder="Agente"
                  :items="agents"
                  item-show="name"
                  :on-input="(name) => getListAgents(name, 'chemical')"
                  :on-select="(agent) => setAgentData({ ...agent, resultIndex: index })"
                  showIconClear />
              </d-col>
              <d-col cols="3">
                <label>Código</label>
                <input type="text" class="form-control" placeholder="Código" v-model="model.agent_code" disabled
                  required />
              </d-col>
              <d-col cols="3">
                <label for="cas">
                  CAS
                  <i class="fas fa-info-circle p-0 fa-xs" id="tooltip-cas" />
                  <d-tooltip target="#tooltip-cas" placement="top">
                    Número CAS (Chemical Abstracts Service)
                  </d-tooltip>
                </label>
                <input type="text" class="form-control" placeholder="cas" v-model="model.agent_cas" disabled required />
              </d-col>
              <d-col cols="3">
                <label>Método</label>
                <input type="text" class="form-control" placeholder="Método" v-model="model.agent_method" disabled
                  required />
              </d-col>
              <d-col cols="3">
                <label>Tipo de amostrador</label>
                <input type="text" class="form-control" placeholder="Tipo de amostrador" v-model="model.sampler_type"
                  required />
              </d-col>
            </d-form-row>
            <d-form-row class="mb-1">
              <d-col cols="3">
                <label>N.º Branco de campo</label>
                <input type="text" class="form-control" placeholder="N.º Branco de campo" v-model="model.white_field_no"
                  required />
              </d-col>
              <d-col cols="2">
                <label>Vazão da bomba <small>(L/min)</small></label>
                <input type="number" class="form-control" step="0.01" min="0" placeholder="Vazão da bomba"
                  v-model.number="model.pump_flow" @input="recalculateVolume(index)" required />
              </d-col>
              <d-col cols="1">
                <label>Volume <small>(L)</small></label>
                <input type="number" class="form-control" placeholder="Volume" v-model="model.volume" disabled
                  required />
              </d-col>
              <d-col cols="auto">
                <label>Temperatura <small>(C˚)</small></label>
                <input type="number" class="form-control" placeholder="Temperatura" v-model="model.temperature"
                  required />
              </d-col>
              <d-col cols="2">
                <label>URL inicial<small>(%)</small></label>
                <input type="number" class="form-control" placeholder="URL inicial" v-model="model.initial_ura"
                  required />
              </d-col>
              <d-col cols>
                <label>Pressão atmosférica</label>
                <input type="number" class="form-control" placeholder="Pressão atmosférica"
                  v-model="model.atmospheric_pressure" required />
              </d-col>
            </d-form-row>
            <d-form-row class="mb-1">
              <d-col cols="3">
                <label>Horário inicial</label>
                <input type="time" class="form-control" placeholder="Horário inicial" v-model="model.initial"
                  @change="recalculateDerivedFields(index)" required />
              </d-col>
              <d-col cols>
                <label>Horário final</label>
                <input type="time" class="form-control" placeholder="Horário final" v-model="model.final"
                  @change="recalculateDerivedFields(index)" required />
              </d-col>
              <d-col cols>
                <label>Intervalo inicial</label>
                <input type="time" class="form-control" placeholder="Intervalo inicial" v-model="model.interval_initial"
                  @change="recalculateDerivedFields(index)" required />
              </d-col>
              <d-col cols>
                <label>Intervalo final</label>
                <input type="time" class="form-control" placeholder="Intervalo final" v-model="model.interval_final"
                  @change="recalculateDerivedFields(index)" required />
              </d-col>
              <d-col cols>
                <label>Tempo total</label>
                <input type="text" class="form-control" placeholder="Tempo total" v-model="model.total_time" disabled
                  required />
              </d-col>
            </d-form-row>
          </d-col>
          <d-col class="col-controls flex align-content-center justify-content-center px-0">
            <div class="icon-controls flex justify-content-center">
              <i class="fas cursor-pointer fa-plus text-success" @click="addRow()"
                v-if="index + 1 === listAgents.length" />
              <i class="fas cursor-pointer fa-minus text-danger" @click="removeRow(index)" />
            </div>
          </d-col>
        </d-form-row>
      </li>
    </ul>
  </d-form-row>
</template>

<script>
import Autocomplete from '_shared/Autocomplete.vue';
import { calculateTotalTime, formatMinutesToHHmm, timeToMinutes } from '_utils/time';
import { calculateVolume } from '_utils/volume';
import Events from '_utils/events';
import AgentMixin from '_common/mixins/AgentMixin';
import { _ADD_SAMPLE_AGENT_TAB_RESULT_, _ADD_SAMPLE_NEW_RESULT_TAB_RESULT_, _DELETE_SAMPLE_RESULT_TAB_RESULT_, AGENT_ROW } from '../SampleModel';

export default {
  name: 'Agents-list',
  mixins: [AgentMixin],
  props: {
    listAgents: {
      type: Array,
      default: () => [{ ...AGENT_ROW }],
    },
  },
  components: {
    Autocomplete,
  },
  methods: {
    addRow() {
      this.listAgents.push({ ...AGENT_ROW });
      Events.$emit(_ADD_SAMPLE_NEW_RESULT_TAB_RESULT_);
    },
    removeRow(index) {
      Events.$emit(_DELETE_SAMPLE_RESULT_TAB_RESULT_, index);
      this.listAgents.splice(index, 1);
      if (this.listAgents.length === 0) {
        this.addRow();
      }
    },
    toggleLoading() {
      this.loading = !this.loading;
      Events.$emit('loading', this.loading);
    },
    setAgentData(agent, reload = true) {
      const row = this.listAgents[agent.resultIndex];
      if (!row) return;

      if (reload) Events.$emit(_ADD_SAMPLE_AGENT_TAB_RESULT_, agent);

      this.setAutocompleteValue(`autocomplete_agent_${agent.resultIndex}`, agent?.name || null);

      this.$set(row, 'agent_id', agent?.id || null);
      this.$set(row, 'agent', agent?.name || null);
      this.$set(row, 'agent_code', agent?.code || null);
      this.$set(row, 'agent_cas', agent?.cas || null);
      this.$set(row, 'agent_method', agent?.method || null);
    },
    recalculateDerivedFields(index) {
      this.recalculateTotalTime(index);
      this.recalculateVolume(index);
    },
    recalculateTotalTime(index) {
      const model = this.listAgents[index];
      if (!model) return;

      const {
        initial,
        final,
        interval_initial: intervalInitial,
        interval_final: intervalFinal,
      } = model;

      const hasMainRange = initial && final;
      const hasInterval = intervalInitial && intervalFinal;

      if (!hasMainRange && !hasInterval) {
        model.total_time = null;
        return;
      }

      const totalTime = calculateTotalTime(initial, final, intervalInitial, intervalFinal);
      model.total_time = formatMinutesToHHmm(totalTime);
    },
    recalculateVolume(index) {
      const model = this.listAgents[index];
      if (!model) return;

      const pumpFlow = model.pump_flow;
      const totalTime = model.total_time;

      if (!pumpFlow || !totalTime) {
        model.volume = null;
        return;
      }

      const totalTimeInMinutes = timeToMinutes(totalTime);
      model.volume = calculateVolume(pumpFlow, totalTimeInMinutes);
    },
    setAutocompleteValue(refName, value) {
      const autocomplete = this.$refs[refName];
      const input = autocomplete?.[0]?.$refs?.input;

      if (input && value) {
        input.value = value;
      }
    },
    setAutocompleteValues() {
      this.$nextTick(() => {
        this.listAgents.forEach((row, index) => {
          const refName = `autocomplete_agent_${index}`;
          this.setAutocompleteValue(refName, row.agent);
        });
      });
    },
  },
  watch: {
    listAgents: {
      handler(value) {
        this.$emit('update:listAgents', value);
        this.setAutocompleteValues();
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.col-controls {
  max-width: 50px;

  .icon-controls {
    display: flex;
    gap: 10px;

    .fas {
      cursor: pointer;
    }
  }
}

.agent-list {
  padding: 0;
  list-style: none;
  width: 100%;

  .cursor-pointer {
    cursor: pointer;
  }
}

.agent-list>li:not(:last-child) .col {
  margin-bottom: 8px;
}
</style>
